<template>
  <div class="p-all" v-if="!isAllowed">
    <a-alert
      message="Invalid Access"
      description="You don't have permission of this page!"
      type="error"
    />
  </div>
  <a-layout-content v-else :class="!isHrd ? 'p-all' : ''">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" :xxl="{ span: 6 }">
        <a-card bordered hoverable class="m-card-w-photo">
          <div slot="cover">
            <img
              alt="profile-pic"
              v-if="data.profile.foto"
              ref="picProfiles"
              :src="$serviceUrl + data.profile.foto + '?' + datePicture"
            />
            <!--<img alt="profile-pic"  ref="picProfiles" :src="getAuth.foto + '?'+datePicture" />-->
            <a-upload
              v-if="getAuth.divisi[0] == 'HRD' && isHrd"
              class="floating-button"
              accept="image/*"
              :showUploadList="false"
              :multiple="false"
              :beforeUpload="beforeUpload"
              :action="handleUpload"
            >
              <a-button type="primary" icon="edit">Ganti Foto</a-button>
            </a-upload>
          </div>
          <a-card-meta>
            <template slot="description">
              <h2 class="m-remove">{{ data.profile.nama }}</h2>
              <h4>{{ data.employee.jabatan }}</h4>
            
              <a-menu
                class="transparent"
                mode="vertical"
                @click="handleClick"
                :selectedKeys="[clicked]"
              >
                <a-menu-item key="profile">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'profile' }
                        : { name: 'hrd.karyawan.profile' }
                    "
                  >
                    <a-icon type="user" />Profile
                  </router-link>
                </a-menu-item>
                <a-menu-item key="dokumen">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'dokumen' }
                        : { name: 'hrd.karyawan.dokumen' }
                    "
                  >
                    <a-icon type="file" />Dokumen
                  </router-link>
                </a-menu-item>
                <a-menu-item key="kepegawaian">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'kepegawaian' }
                        : { name: 'hrd.karyawan.kepegawaian' }
                    "
                  >
                    <a-icon type="solution" />Kepegawaian
                  </router-link>
                </a-menu-item>
                <a-menu-item key="anggota">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'anggota' }
                        : { name: 'hrd.karyawan.anggota' }
                    "
                  >
                    <a-icon type="solution" />Anggota Keluarga
                  </router-link>
                </a-menu-item>
                <a-menu-item key="plafon_kesehatan">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'plafon_kesehatan' }
                        : { name: 'hrd.karyawan.plafon_kesehatan' }
                    "
                  >
                    <a-icon type="solution" />Plafon Kesehatan
                    </router-link>
                </a-menu-item>
                <a-menu-item key="bpjs">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'bpjs' }
                        : { name: 'hrd.karyawan.bpjs' }
                    "
                  >
                    <a-icon type="fork" />BPJS
                  </router-link>
                </a-menu-item>
                <a-menu-item key="fasilitasKerja" v-if="isHrd">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'fasilitasKerja' }
                        : { name: 'hrd.karyawan.fasilitasKerja' }
                    "
                  >
                    <a-icon type="safety-certificate" />Fasilitas Kerja
                  </router-link>
                </a-menu-item>
                <a-menu-item key="cuti">
                  <router-link
                    :to="
                      !isHrd ? { name: 'cuti' } : { name: 'hrd.karyawan.cuti' }
                    "
                  >
                    <a-icon type="rocket" />Cuti
                  </router-link>
                </a-menu-item>
              </a-menu>
            </template>
          </a-card-meta>
        </a-card>
      </a-col>
      <a-col
        :class="isMobile ? 'm-top' : ''"
        :xs="{ span: 24 }"
        :lg="{ span: 16 }"
        :xxl="{ span: 18 }"
      >
        <router-view :data="data" :tlc="this.tlc"/>
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  props: ["tlc", "spesialFor"],
  name: "index.profile",
  data() {
    return {
      data: {
        profile: { foto: null },
        employee: { jabatan: null },
      },
      foto: [],
      current: this.$route.name,
      isHrd: false,
      isAllowed: true,
      datePicture: Date(),
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    clicked() {
      if (_.includes(this.$route.name, ".")) {
        let splits = _.split(this.$route.name, ".");
        return splits[splits.length - 1];
      } else {
        return this.$route.name;
      }
    },
    
  },
  created() {
    if (
      this.$router.currentRoute.name == "hrd.karyawan.profile" ||
      this.getAuth.divisi[0] == "HRD"
    ) {
      this.isHrd = true;
    }
  },
  activated(){
    if (
      this.$router.currentRoute.name == "hrd.karyawan.profile" ||
      this.getAuth.divisi[0] == "HRD"
    ) {
      this.isHrd = true;
    } 
  },
  mounted() {    
    this.fetching();
    Event.$on("fetching", this.fetching);
    Event.$on("updateMember", this.updateMember);
  },
  watch: {
    tlc() {
      this.fetching();
      this.current = "profile";
    },
  },
  methods: {
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "master_karyawan",
        params: {
          tlc: this.tlc,
          tlc_login: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.isAllowed = true;
          this.data = response.data;          
        })
        .catch((err) => {
          if (err.response.data.message == "invalid access") {
            this.isAllowed = false;
          }
        });
    },
    handleClick(e) {
      this.current = e.key;
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleUpload(file) {
      let data = new FormData();
      data.append("foto", file);
      data.append("tlc", this.tlc);

      axios({
        method: "post",
        url: this.$serviceUrl + "master_karyawan/edit_foto_karyawan",
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessage("success-edit");
          this.$refs.picProfiles.src = "";
          this.datePicture = new Date();
          this.$router.go();
        })
        .catch((err) => {
          return err;
        });
      // }
    },

    updateMember(value){
      console.log('updated');
      
      this.data.member = value
    }
  },
};
</script>

<style>

.m-card-w-photo .ant-card-cover div .floating-button {
    position: absolute;
    top: 10px;
    right: 10px;
}

</style>
